import { Action } from "@ngrx/store";

export enum KycNotificationType {
	Default,
	Warning,
	Danger,
	Success,
}

export interface KycNotification {
	message: string;
	linkText: string;
	destination: string | Action;
	type: KycNotificationType;
	interpolateParams?: object | undefined;
}

export interface DefineNotificationParams {
	message: string;
	linkText: string;
	destination: string | Action;
	type?: KycNotificationType;
	interpolateParams?: object | undefined;
}
